import { render, staticRenderFns } from "./UsersDetails.vue?vue&type=template&id=254563bc&scoped=true&"
import script from "./UsersDetails.vue?vue&type=script&lang=js&"
export * from "./UsersDetails.vue?vue&type=script&lang=js&"
import style0 from "./UsersDetails.vue?vue&type=style&index=0&id=254563bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254563bc",
  null
  
)

component.options.__file = "UsersDetails.vue"
export default component.exports